import { ReactComponent as IconDataElement } from "@/assets/svgs/data-element-purple.svg";
import { ReactComponent as Authorization } from "@/assets/svgs/document-verified.svg";
import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import { ReactComponent as IconIssuedBy } from "@/assets/svgs/issued-by.svg";
import { ReactComponent as TradeTrust } from "@/assets/svgs/logo-tradetrust.svg";
import { ReactComponent as IconVerifiedBy } from "@/assets/svgs/verified-by.svg";
import { ReactComponent as IconNotVerified } from '@/assets/svgs/not-verified.svg'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from "@/utils/rem";

export default function VerifiedByModal({
	issuerName,
	elementName,
	date,
	verifiedBy = "SGTraDex and TradeTrust",
	visible,
	close,
	isVerified = true,
}) {

	return (
		<Modal visible={visible} variant="large" close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										{isVerified ? <IconVerifiedBy /> : <IconNotVerified />}
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										{isVerified ? 'Verified Document' : 'Document Verification Failed'}
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				{isVerified ?
					<>
						<CardConfigure.Body>
							<CardConfigure.Body.Col>
								<div className="card-configure__sub-header">
									<div className="verified-document">
										<div className={`eclip-landing-eclip-box`}>
											<IconDataElement />
										</div>
										<div className="verified-document__description">
											<span className="verified-document__description__title">
												{elementName || "-"}
											</span>
											{isVerified ?
												<span className="verified-document__description__subttitle">
													Issued on {date} by{" "}
													{issuerName || "-"}
												</span> :
												<></>
											}
										</div>
									</div>
								</div>

								<div className="verified-document__content">
									<div className="row mb-30">
										<div className="column">
											<div>
												<IconIssuedBy />
											</div>
											<span>
												Issued by{" "}
												<span className="bold">
													{issuerName || "-"}
												</span>
											</span>
										</div>
									</div>
									<div className="row">
										<div className="column">
											<div>
												<IconVerifiedBy />
											</div>
											<div>
												<div>Verified by</div>
												<div className="bold">{verifiedBy}</div>
											</div>
										</div>
										<div className="column">
											<div>
												<Authorization />
											</div>
											<div>
												<div>Documents have not been </div>{" "}
												<div>
													tampered from its original state
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="learn-more">
									<span>Powered by</span>
									<span className="icon">
										<TradeTrust />
									</span>
									<a
										className="text transaction--underline"
										href="https://docs.tradetrust.io/docs/introduction/what-is-tradetrust"
										rel="noopener noreferrer"
										target="_blank"
									>
										Learn more
									</a>
								</div>
							</CardConfigure.Body.Col>
						</CardConfigure.Body>
					</> :
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="verified-document__content verified-document__content--error">
								There was an issue with attachments in this transaction. Please check with the issuing party.
							</div>
							<div className="learn-more">
								<span>Powered by</span>
								<span className="icon">
									<TradeTrust />
								</span>
								<a
									className="text transaction--underline"
									href="https://docs.tradetrust.io/docs/introduction/what-is-tradetrust"
									rel="noopener noreferrer"
									target="_blank"
								>
									Learn more
								</a>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				}
			</CardConfigure>
		</Modal>
	);
}
